const getProfilePic = (ownerId) =>
  `https://firebasestorage.googleapis.com/v0/b/gobeyond-app.appspot.com/o/profiles%2F${ownerId}?alt=media`;

export default getProfilePic;
